import styled from 'styled-components'

export const CalendarEventDescriptionUi = styled.div`
  overflow-y: auto;
  max-height: 160px;
`
